<template>
  <a-card :loading="loadingDorms">
    <h2>Instancje</h2>
    <a-list :data-source="dorms" item-layout="horizontal" size="small">
      <a-list-item slot="renderItem" slot-scope="item">
        <a-list-item-meta>
          <a-badge slot="title" :status="'success'" :text="item.name"/>
        </a-list-item-meta>
        <div>
          <div class="status">
            <div v-for="(status, index) in item.statusGraph" :key="index" :class="status"></div>
          </div>
        </div>
      </a-list-item>
    </a-list>
    <div style="text-align: right;">
      <small>
        <a-tooltip>
          <template #title>
            Jeśli ostatnio widziany więcej niż 10 minut temu to błąd, jak 2 minuty temu to problem.
          </template>
          <a-icon type="question-circle"/>
        </a-tooltip>
      </small>
    </div>
  </a-card>
</template>

<script>
import httpClient from "@/utils/httpClient";

export default {
  name: "DormWidget",
  data() {
    return {
      dorms: [],
      loadingDorms: true
    }
  },
  mounted() {
    this.loadDorms()
  },
  methods: {
    loadDorms() {
      this.loadingDorms = true
      httpClient
          .get(`/admin/dorms`)
          .then((response) => {
            this.dorms = response;
          }).catch((error) => {
            if (error.response.status !== 401) {
              this.$message.error("Wystąpił błąd z pobraniem listy lokalizacji!")
            }
          }).finally(() => {
            this.loadingDorms = false
          })
    },
  }
}
</script>

<style scoped>
.status > div {
  display: inline-block;
  background-color: rgb(220, 220, 220);
  width: 7px;
  height: 1rem;
  margin-left: 2px;
  border-radius: 3px;
  transition: 150ms all;
}

.status > div:hover {
  transform: scale(1.4);
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);
}

.status .active {
  background-color: #52c41a;
}

.status .problem {
  background-color: #faad14;
}

.status .error {
  background-color: #f5222d;
}
</style>
